import { render } from "./VinksPartnerAZS.vue?vue&type=template&id=3b054342&scoped=true"
import script from "./VinksPartnerAZS.vue?vue&type=script&lang=js"
export * from "./VinksPartnerAZS.vue?vue&type=script&lang=js"

import "./VinksPartnerAZS.vue?vue&type=style&index=0&id=3b054342&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b054342"]])

export default __exports__